module.exports = {
    "className": "Card",
    "limit": 10,
    "showExport": false,
    "columns": [
      {
        "columnName": "objectId",
            "type": "string"
      },
      {
        columnName: "cardImg",
        columnLabel: "Card Image",
        type: "ParseFile"
      },
      {
        "columnName": "cardType",
        columnLabel: "Card Type",
        "type": "string"
      },
      {
        "columnName": "cardName",
        columnLabel: "Card Name",
        "type": "string"
      },
      {
        "columnName": "createdAt",
            "type": "Date"
      },
      {
        "columnName": "updatedAt",
            "type": "Date"
      }
    ]
}  


// WEBPACK FOOTER //
// ./components/CardImages/CardSchema.js